export enum SwatchesLayout {
  /** Square swatches that wrap, used by the side panel. */
  WRAP = 'wrap',
  /** Circular swatches that wrap, used by the mobile colour picker. */
  ROUND_WRAP = 'round-wrap',
  /** Circular swatches in a fixed six-column grid, used by the colour popup. */
  ROUND_GRID = 'round-grid',
}

export const DEFAULT_SWATCH_SIZE = 40;
/** Marks a round swatch grid so the colour popup can end its visible area halfway through one of its rows. */
export const SCROLL_PEEK_ROW_ATTRIBUTE = 'data-scroll-peek-row';
export const SCROLL_PEEK_ITEM_SELECTOR = `[${SCROLL_PEEK_ROW_ATTRIBUTE}] > *`;
/** Round swatches fill their grid column; the height follows from the square aspect ratio. */
export const ROUND_SWATCH_WIDTH = '100%';
export const ROUND_SWATCH_HEIGHT = 'auto';
export const ROUND_SWATCH_RADIUS = '50%';

export interface SwatchesProps {
  className?: string;
  colors: string[];
  layout?: SwatchesLayout;

  onClick(color: string): void;
  showAddButton?: boolean;
  onClickAdd?(): void;
  hasCustomMargins?: boolean;
}
